/**
 * 展示上传弹窗，公共组件
 */
import Decorate from '@tencent/spaui-decorate'
import UploadChannelPkg from 'biz-components/UploadChannelPkg'

export const dialog = new Decorate(UploadChannelPkg)

export const handleClose = () => {
    dialog.setProps({
        show: false,
    })
}

export const showUploadDialog = props => {
    dialog.setProps({
        show: true,
        onClose: handleClose,
        onCancel: handleClose,
        ...props,
        children: null,
    })
}
export default showUploadDialog
